module.exports = __webpack_public_path__ + "img/dongzhuoer.a167c63e.jpeg";